import React, { Component } from "react";
import { Card, Icon, Input, Button, Modal, Form } from "antd";
import BacklinksLayout from "./BacklinksLayout";
import ModalTitle from "../shared/ModalTitle/ModalTitle";

const InputGroup = Input.Group;
class BacklinksForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      competitorsModalVisible: false,
      factorsModalVisible: false,
      domain: "",
      domainValidationError: ""
    };

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.toggleCompetitorsModal = this.toggleCompetitorsModal.bind(this);
    this.toggleFactorsModal = this.toggleFactorsModal.bind(this);
  }

  handleInputChange = event => {
    this.setState({
      domain: event.target.value,
      domainValidationError: ""
    });
  };

  showModal(event) {
    // open modal only domain is valid
    event.preventDefault();
    const regex = /([a-z0-9]+\.)*[a-z0-9]+\.[a-z]+/;
    let domain = this.state.domain.toLowerCase().trim();
    domain = domain.replace("https://", "").replace("http://", "");

    if (regex.test(domain)) {
      this.setState({
        domain: domain,
        modalVisible: true,
        domainValidationError: ""
      });
    } else {
      this.setState({
        domainValidationError: "Provide a valid domain or url"
      });
    }
  }

  closeModal() {
    this.setState({
      modalVisible: false,
      domain: "",
      domainValidationError: ""
    });
  }

  toggleCompetitorsModal(event) {
    event.currentTarget.blur();
    this.setState({competitorsModalVisible: !this.state.competitorsModalVisible});
  }

  toggleFactorsModal(event) {
      event.currentTarget.blur();
      this.setState({factorsModalVisible: !this.state.factorsModalVisible});
  }

  render() {
    return (
      <Card className="analysis-form-card">
        <Form onSubmit={this.showModal} className="analysis-form">
          <Form.Item
            validateStatus={this.state.domainValidationError ? "error" : "validating"}
            help={this.state.domainValidationError ? this.state.domainValidationError : ""}>
            <InputGroup compact size="large">
              <div className="compact-input-group">
                <Input
                  prefix={<Icon type="global" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="Enter domain or url"
                  name="domain"
                  size="large"
                  value={this.state.domain}
                  onChange={event => this.handleInputChange(event)}
                />
                
                <Button onClick={event => this.toggleCompetitorsModal(event)} className="modal-trigger flexbox align-center" icon="shop" size="large">
                    Competitors
                </Button>

                <Button onClick={event => this.toggleFactorsModal(event)} className="modal-trigger flexbox align-center" icon="unordered-list" size="large">
                    Factors
                </Button>

                <Button htmlType="submit" type="primary" size="large">
                  Analyze URL
                </Button>
              </div>
              <Modal
                className="backlinks-modal"
                title={<ModalTitle title="Backlinks for:" meta={this.state.domain} />}
                visible={this.state.modalVisible}
                onCancel={this.closeModal}
                footer={null}
                centered
                destroyOnClose>
                <BacklinksLayout domain={this.state.domain} />
              </Modal>

              <Modal
                  title="Add Competitors"
                  visible={this.state.competitorsModalVisible}
                  onCancel={this.toggleCompetitorsModal}
                  footer={null}
                  destroyOnClose
                  >
                  The competitors will go here
              </Modal>

              <Modal
                  title="Select Factors"
                  visible={this.state.factorsModalVisible}
                  onCancel={this.toggleFactorsModal}
                  footer={null}
                  destroyOnClose
                  >
                  The factors will go here
              </Modal>
            </InputGroup>
          </Form.Item>
        </Form>
      </Card>
    );
  }
}

export default BacklinksForm;
